<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          :text="partnerDetail.name"
          :image="partnerDetail.image"
        />
      </v-col>
    </v-row>

    <v-row justify="space-around" style="margin-top: -30px" class="mx-2">
      <v-btn
        elevation="5"
        class="rounded-lg"
        @click="handleClickTab('list_reward')"
        :style="{
          backgroundColor: type == 'list_reward' ? site.color : 'white',
        }"
        style="width: 130px"
      >
        <p
          class="text-justify mb-0"
          :style="{
            color: type == 'list_reward' ? 'white' : 'black',
          }"
        >
          <v-icon
            left
            :style="{
              color: type == 'list_reward' ? 'white' : site.color,
            }"
            style="margin-right: 0px"
            >mdi-format-list-bulleted</v-icon
          >
          {{ $t("list") }}
        </p>
      </v-btn>
      <v-btn
        elevation="5"
        class="rounded-lg"
        @click="handleClickTab('my_reward')"
        :style="{
          backgroundColor: type == 'my_reward' ? site.color : '',
        }"
        style="width: 130px"
      >
        <p
          class="text-justify mb-0"
          :style="{
            color: type == 'my_reward' ? 'white' : 'black',
          }"
        >
          <v-icon
            left
            :style="{
              color: type == 'my_reward' ? 'white' : site.color,
            }"
            style="margin-right: 0px"
            >mdi-wallet-giftcard</v-icon
          >
          {{ $t("menuCoupon") }}
        </p>
      </v-btn>
    </v-row>

    <!-- list_reward -->

    <v-container class="pt-0 mt-2" v-if="type == 'list_reward'">
      <v-row class="mt-1">
        <v-col
          v-for="(item, index) in dataItems"
          :key="index"
          class="px-2 py-2"
          cols="6"
          sm="4"
          lg="2"
          md="3"
        >
          <div>
            <v-card
              class="rounded-lg pa-3 card-container"
              outlined
              elevation="1"
              width="100%"
              style="border: none"
              @click="viewReward(item)"
            >
              <v-img
                :cover="true"
                :aspect-ratio="1"
                width="100%"
                :lazy-src="require('@/assets/images/image.png')"
                :src="item.image_url"
              >
              </v-img>

              <p
                class="title-mission text-start mb-auto text-subtitle-2 black--text"
                v-snip="{ lines: 2 }"
              >
                {{ item.name }}
              </p>

              <v-row class="bottomleft mb-0 text-start text-subtitle-2">
                <div class="ma-1">
                  <PointSymbol
                    v-if="
                      Array.isArray(item.point_used) &&
                      item.point_used.length > 0
                    "
                    :type="item.point_used[0].point_type_type"
                    :symbol="item.point_used[0].point_type_symbol"
                    :color="item.point_used[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="20"
                  />
                </div>
                <p
                  v-if="
                    Array.isArray(item.point_used) && item.point_used.length > 0
                  "
                  class="pa-0 my-1 pl-0 text-truncate"
                  :style="{ color: site.color }"
                >
                  {{ item.point_used[0].point | commaPoint }}
                  {{ item.point_used[0].point_type_name }}
                </p>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- my_reward -->

    <v-container class="pt-0 mt-2" v-if="type == 'my_reward'">
      <v-row class="mt-1">
        <v-col
          v-for="(item, index) in dataMyItems"
          :key="index"
          class="px-2 py-2"
          cols="6"
          sm="4"
          lg="2"
          md="3"
        >
          <div>
            <v-card
              class="rounded-lg pa-3 card-container"
              outlined
              elevation="1"
              width="100%"
              style="border: none"
              @click="viewReward(item)"
            >
              <v-img
                :cover="true"
                :aspect-ratio="1"
                width="100%"
                :lazy-src="require('@/assets/images/image.png')"
                :src="item.image_url"
              >
              </v-img>

              <p
                class="title-mission text-start mb-auto text-subtitle-2 black--text"
                v-snip="{ lines: 2 }"
              >
                {{ item.name }}
              </p>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- no data -->
    <div
      v-if="
        (type == 'list_reward' && !dataItems.length) ||
        (type == 'my_reward' && !dataMyItems.length)
      "
    >
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <!--dialog detail reward -->
    <dialogDetailReward
      :dialogDetail="dialogDetail"
      :site="site"
      :item="itemFocus"
      :keyComponent="1"
      :hidePointBox="type == 'my_reward' ? true : false"
      :hideAmountBox="type == 'my_reward' ? true : false"
      :hideSubmit="type == 'my_reward' ? true : false"
      @redeemReward="redeemReward"
      @close="dialogDetail = false"
    />

    <!-- confirm reward -->
    <dialogConfirmRedeemComponent
      :dialogConfirmRedeem="dialogConfirmRedeem"
      :site="site"
      :item="itemFocus"
      :keyComponent="2"
      :quantity="1"
      @confirmRedeemReward="confirmRedeemReward"
      @close="dialogConfirmRedeem = false"
    />
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import HeaderTextBg from "@/components/headerTextBg.vue";
import dialogDetailReward from "@/components/reward/dialogDetailPartner.vue";
import dialogConfirmRedeemComponent from "@/components/reward/dialogConfirmRedeem.vue";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    dialogDetailReward,
    dialogConfirmRedeemComponent,
    PointSymbol,
  },
  data: () => ({
    type: "list_reward",
    dataItems: [],
    dataMyItems: [],
    itemFocus: {},
    partnerDetail: {
      id: null,
      name: "",
      image: "",
      partner_code: "",
    },
    pageItem: 1,
    pageMyItem: 1,
    dialogDetail: false,
    dialogConfirmRedeem: false,
  }),
  async created() {
    this.isAppLoading(true);
    this.partnerDetail.partner_code = this.$route.params.partner_code;
    await this.getPartnerDetail();
    await this.getListReward();
    await this.getMyReward();
    this.isAppLoading(false);
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  methods: {
    async getPartnerDetail() {
      try {
        const response = await Axios.post("partner/getPartnerDetail", {
          partner_code: this.partnerDetail.partner_code,
          partner_type: "reward",
        });
        const dataResponse = response?.data;
        if (dataResponse.status == "success") {
          if (dataResponse.data) {
            this.partnerDetail = {
              ...dataResponse.data,
            };
          }
        } else {
          this.$router.push({ name: "reward" });
        }
      } catch (err) {
        console.log("getPartnerDetail", err);
        this.$router.push({ name: "reward" });
      }
    },
    async getListReward() {
      try {
        const response = await Axios.post("reward/listRewardPartner", {
          partner_code: this.partnerDetail.partner_code,
        });
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          if (Array.isArray(dataResponse.data)) {
            this.dataItems = [...dataResponse.data];
          }
        }
      } catch (err) {
        console.log("getListReward", err);
      }
    },
    async getMyReward() {
      try {
        const response = await Axios.post("reward/listMyRewardPartner", {
          partner_code: this.partnerDetail.partner_code,
        });
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          if (Array.isArray(dataResponse.data)) {
            this.dataMyItems = [...dataResponse.data];
          }
        }
      } catch (err) {
        console.log("getListReward", err);
      }
    },
    viewReward(param) {
      this.itemFocus = { ...param };
      this.dialogDetail = true;
    },
    redeemReward() {
      this.dialogDetail = false;
      this.dialogConfirmRedeem = true;
    },
    async confirmRedeemReward() {
      this.isAppLoading(true);
      this.dialogConfirmRedeem = false;
      try {
        const response = await Axios.post("reward/redeemRewardPartner", {
          partner_code: this.partnerDetail.partner_code,
          reward: this.itemFocus,
        });
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          this.$swal.fire({
            icon: "success",
            text: this.$t("redeemSuccess"),
            showConfirmButton: false,
            timer: 3000,
          });
          await this.getListReward();
          await this.getMyReward();
        } else {
          this.$swal.fire({
            icon: "error",
            text: this.$t("errRedeemFail"),
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (err) {
        console.log("redeemRewardPartner", err);
        this.$swal.fire({
          icon: "error",
          text: this.$t("errRedeemFail"),
          showConfirmButton: false,
          timer: 3000,
        });
      }
      this.isAppLoading(false);
    },
    handleClickTab(param) {
      this.type = param;
    },
  },
  filters: {
    commaPoint(value) {
      const number = Number(value);
      if (number == 0) {
        return "0";
      } else if (!isNaN(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "";
    },
  },
};
</script>

<style scoped>
.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}
.empty {
  opacity: 1;
}
.card-container {
  position: relative;
  aspect-ratio: 1 / 1.5;
}
</style>
